import { render } from "./SlideHeroItem3.vue?vue&type=template&id=33827380&scoped=true"
import script from "./SlideHeroItem3.vue?vue&type=script&lang=js"
export * from "./SlideHeroItem3.vue?vue&type=script&lang=js"

import "./SlideHeroItem3.vue?vue&type=style&index=0&id=33827380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33827380"]])

export default __exports__